import { getRouteApi } from '@tanstack/react-router'

import { useTenants } from './queries'

const appShellRouteApi = getRouteApi('/app/$tenantSlug')

/**
 * Resolve o tenant atual a partir do slug na URL (`:tenantSlug`) e da lista de tenants do
 * usuario, ja em cache via TanStack Query (populada pelo guard de `/app/$tenantSlug`). Uso
 * restrito a paginas dentro dessa subarvore de rotas.
 */
export function useCurrentTenant() {
  const { tenantSlug } = appShellRouteApi.useParams()
  const tenantsQuery = useTenants()
  const tenants = tenantsQuery.data ?? []
  const tenant = tenants.find((candidate) => candidate.slug === tenantSlug) ?? null

  return {
    tenant,
    tenants,
    isLoading: tenantsQuery.isLoading,
  }
}
